import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Authenticator } from '@aws-amplify/ui-react';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


 
  <React.StrictMode>

  <Authenticator.Provider>
  <BrowserRouter>

    <App />

  </BrowserRouter>
  </Authenticator.Provider>

  </React.StrictMode>






);

